import { Model } from "@vuex-orm/core";
import ListItem from "./ListItem";

export default class ListType extends Model {
  static entity = "listTypes";

  static fields() {
    return {
      id: this.attr(),
      name: this.attr(),
      system: this.boolean(true),
      code: this.attr(),
      items: this.hasMany(ListItem, "listTypeId")
    };
  }
}
